import './Loader.scss';

export const Loader = () => {
  return (
    <div className="loader__wrapper">
      <img src="img/icons/loader.gif" alt="" className="loader__image" />
    </div>
  );
};
